import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { ConsultaPadronComponent } from './consulta-padron/consulta-padron.component';
// import { GestionReclamosComponent } from './gestion-reclamos/gestion-reclamos.component';
import { LayoutComponent } from './layout/layout.component';


export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      //{ path: 'consulta-padron', loadComponent: () => import('./consulta-padron/consulta-padron.component') },
      { path: 'consulta-padron', redirectTo: '/gestion-reclamo-no-voto', pathMatch: 'full' }, // changed due to new requirement: generate excuses for not voting
      { path: 'gestion-reclamo', loadComponent: () => import('./gestion-reclamos/gestion-reclamos.component') },
      { path: 'gestion-reclamo-no-voto', loadComponent: () => import('./gestion-reclamos-no-voto/gestion-reclamos-no-voto.component') },
      { path: 'resultado-padron', loadComponent: () => import('./resultado-padron/resultado-padron.component') },
      { path: 'reclamo-enviado', loadComponent: () => import('./reclamo-msj/reclamo-msj.component') },
      { path: 'infractores', loadComponent: () => import('./infractores/infractores.component') },
      //{ path: '', redirectTo: '/consulta-padron', pathMatch: 'full' }, // // changed due to new requirement: generate excuses for not voting
      { path: '', redirectTo: '/infractores', pathMatch: 'full' }, //se redirecciona a infractores
      { path: 'reclamo-enviado-no-voto', loadComponent: () => import('./reclamo-msj-no-voto/reclamo-msj-no-voto.component') },
    ],

  }
];




